import { useEffect, useState } from 'react';
import api from '../../../api/axiosInstance';
import { toast } from 'react-toastify';
import Unauthorized from '../../../Components/custom/Unauthrized';

const Variables = (props) => {
  const [variables, setVariables] = useState([]);

  const saveVariables = () => {
    var config = {
      method: 'patch',
      url: process.env.REACT_APP_API_URL + 'Variables/UpdateVariables',
      headers: {
        'Access-Control-Allow-Origin': process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
      data: variables,
    };

    api(config)
      .then(function (response) {
        console.log(response);
        if (response.data.statusCode === 200) {
          toast.success('Updated');
        }
      })
      .catch(function (error) {});
  };
  useEffect(() => {
    const GetVariables = () => {
      var config = {
        method: 'get',
        url: process.env.REACT_APP_API_URL + 'Variables/GetVariables',
        headers: {
          'Access-Control-Allow-Origin': process.env.REACT_APP_Host,
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        },
      };

      api(config)
        .then(function (response) {
          console.log(response);
          if (response.data.statusCode === 200) {
            setVariables(response.data.content);
          }
        })
        .catch(function (error) {
          if (error.response.status === 401) {
            localStorage.clear();
            window.location = '/Login';
            window.location.reload();
          }
        });
    };
    GetVariables();
  }, []);
  return (
    <>
      {props.userPermissions.viewDashboardVariables == false ? (
        <Unauthorized />
      ) : (
        <>
          <div className='container-fluid mt-30'>
            <div className='row'>
              <div className='col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-20 text-center'>
                <h3 className='text-center'>Dashboard Variables</h3>
                <br></br>
                <button
                  className='btn btn-primary btn-sm cts-btn-primary'
                  onClick={() => saveVariables()}
                >
                  Save Changes
                </button>
              </div>
              {/* <div className="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-4 mb-20">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title text-center w-100">KPI 2.2</h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-12">
                    <h5 className="text-center"></h5>
                    <div className="self-align-content variable-switch">
                      <div className="form-check form-switch">
                        <label
                          className="form-check-label f-left"
                          for="flexSwitchCheckDefault"
                        >
                          Number
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="flexSwitchCheckDefault"
                          checked={variables.kpi22type}
                          onChange={(e) =>
                            setVariables((prevState) => ({
                              ...prevState,
                              kpi22type: e.target.checked,
                            }))
                          }
                        />
                        <label
                          className="form-check-label"
                          for="flexSwitchCheckDefault"
                        >
                          Percentage
                        </label>
                      </div>
                    </div>
                    <hr></hr>
                    <div className="row">
                      <div className="col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center">
                        <b>Range Down</b>
                        <input
                          className="form-control form-control-sm text-center"
                          type="number"
                          value={variables.kpi22below}
                          onChange={(e) =>
                            setVariables((prevState) => ({
                              ...prevState,
                              kpi22below: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div className="col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center">
                        <b>Range</b>
                        <input
                          className="form-control form-control-sm text-center"
                          type="number"
                          value={variables.kpi22}
                          onChange={(e) =>
                            setVariables((prevState) => ({
                              ...prevState,
                              kpi22: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div className="col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center">
                        <b>Range Up</b>
                        <input
                          className="form-control form-control-sm text-center"
                          type="number"
                          value={variables.kpi22above}
                          onChange={(e) =>
                            setVariables((prevState) => ({
                              ...prevState,
                              kpi22above: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
              <div className='col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-4 mb-20'>
                <div className='card'>
                  <div className='card-header'>
                    <h3 className='card-title text-center w-100'>
                      KPI 6: Never Logged Students
                    </h3>
                  </div>
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-12'>
                        <h5 className='text-center'></h5>
                        <div className='self-align-content variable-switch'>
                          <div className='form-check form-switch'>
                            <label
                              className='form-check-label f-left'
                              for='flexSwitchCheckDefault'
                            >
                              Number
                            </label>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              role='switch'
                              id='flexSwitchCheckDefault'
                              checked={variables.kpi6type}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi6type: e.target.checked,
                                }))
                              }
                            />
                            <label
                              className='form-check-label'
                              for='flexSwitchCheckDefault'
                            >
                              Percentage
                            </label>
                          </div>
                        </div>
                        <hr></hr>
                        <div className='row'>
                          <div className='col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center'>
                            <b>Range Down</b>
                            <input
                              className='form-control form-control-sm text-center'
                              type='number'
                              value={variables.kpi6below}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi6below: e.target.value,
                                }))
                              }
                            />
                          </div>
                          <div className='col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center'>
                            <b>Range</b>
                            <input
                              className='form-control form-control-sm text-center'
                              type='number'
                              value={variables.kpi6}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi6: e.target.value,
                                }))
                              }
                            />
                          </div>
                          <div className='col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center'>
                            <b>Range Up</b>
                            <input
                              className='form-control form-control-sm text-center'
                              type='number'
                              value={variables.kpi6above}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi6above: e.target.value,
                                }))
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-4 mb-20'>
                <div className='card'>
                  <div className='card-header'>
                    <h3 className='card-title text-center w-100'>
                      KPI 7: Logged Students vs Total Number
                    </h3>
                  </div>
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-12'>
                        <h5 className='text-center'></h5>
                        <div className='self-align-content variable-switch'>
                          <div className='form-check form-switch'>
                            <label
                              className='form-check-label f-left'
                              for='flexSwitchCheckDefault'
                            >
                              Number
                            </label>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              role='switch'
                              id='flexSwitchCheckDefault'
                              checked={variables.kpi7type}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi7type: e.target.checked,
                                }))
                              }
                            />
                            <label
                              className='form-check-label'
                              for='flexSwitchCheckDefault'
                            >
                              Percentage
                            </label>
                          </div>
                        </div>
                        <hr></hr>
                        <div className='row'>
                          <div className='col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center'>
                            <b>Range Down</b>
                            <input
                              className='form-control form-control-sm text-center'
                              type='number'
                              value={variables.kpi7below}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi7below: e.target.value,
                                }))
                              }
                            />
                          </div>
                          <div className='col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center'>
                            <b>Range</b>
                            <input
                              className='form-control form-control-sm text-center'
                              type='number'
                              value={variables.kpi7}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi7: e.target.value,
                                }))
                              }
                            />
                          </div>
                          <div className='col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center'>
                            <b>Range Up</b>
                            <input
                              className='form-control form-control-sm text-center'
                              type='number'
                              value={variables.kpi7above}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi7above: e.target.value,
                                }))
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-4 mb-20'>
                <div className='card'>
                  <div className='card-header'>
                    <h3 className='card-title text-center w-100'>
                      KPI 14: Never Logged Teacher
                    </h3>
                  </div>
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-12'>
                        <h5 className='text-center'></h5>
                        <div className='self-align-content variable-switch'>
                          <div className='form-check form-switch'>
                            <label
                              className='form-check-label f-left'
                              for='flexSwitchCheckDefault'
                            >
                              Number
                            </label>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              role='switch'
                              id='flexSwitchCheckDefault'
                              checked={variables.kpi8type}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi8type: e.target.checked,
                                }))
                              }
                            />
                            <label
                              className='form-check-label'
                              for='flexSwitchCheckDefault'
                            >
                              Percentage
                            </label>
                          </div>
                        </div>
                        <hr></hr>
                        <div className='row'>
                          <div className='col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center'>
                            <b>Range Down</b>
                            <input
                              className='form-control form-control-sm text-center'
                              type='number'
                              value={variables.kpi8below}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi8below: e.target.value,
                                }))
                              }
                            />
                          </div>
                          <div className='col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center'>
                            <b>Range</b>
                            <input
                              className='form-control form-control-sm text-center'
                              type='number'
                              value={variables.kpi8}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi8: e.target.value,
                                }))
                              }
                            />
                          </div>
                          <div className='col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center'>
                            <b>Range Up</b>
                            <input
                              className='form-control form-control-sm text-center'
                              type='number'
                              value={variables.kpi8above}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi8above: e.target.value,
                                }))
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-4 mb-20">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title text-center w-100">KPI 10</h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-12">
                    <h5 className="text-center"></h5>
                    <div className="self-align-content variable-switch">
                      <div className="form-check form-switch">
                        <label
                          className="form-check-label f-left"
                          for="flexSwitchCheckDefault"
                        >
                          Number
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="flexSwitchCheckDefault"
                          checked={variables.kpi10type}
                          onChange={(e) =>
                            setVariables((prevState) => ({
                              ...prevState,
                              kpi10type: e.target.checked,
                            }))
                          }
                        />
                        <label
                          className="form-check-label"
                          for="flexSwitchCheckDefault"
                        >
                          Percentage
                        </label>
                      </div>
                    </div>
                    <hr></hr>
                    <div className="row">
                      <div className="col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center">
                        <b>Range Down</b>
                        <input
                          className="form-control form-control-sm text-center"
                          type="number"
                          value={variables.kpi10below}
                          onChange={(e) =>
                            setVariables((prevState) => ({
                              ...prevState,
                              kpi10below: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div className="col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center">
                        <b>Range</b>
                        <input
                          className="form-control form-control-sm text-center"
                          type="number"
                          value={variables.kpi10}
                          onChange={(e) =>
                            setVariables((prevState) => ({
                              ...prevState,
                              kpi10: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div className="col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center">
                        <b>Range Up</b>
                        <input
                          className="form-control form-control-sm text-center"
                          type="number"
                          value={variables.kpi10above}
                          onChange={(e) =>
                            setVariables((prevState) => ({
                              ...prevState,
                              kpi10above: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
              <div className='col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-4 mb-20'>
                <div className='card'>
                  <div className='card-header'>
                    <h3 className='card-title text-center w-100'>
                      KPI 15: Logged Teachers vs Total Number
                    </h3>
                  </div>
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-12'>
                        <h5 className='text-center'></h5>
                        <div className='self-align-content variable-switch'>
                          <div className='form-check form-switch'>
                            <label
                              className='form-check-label f-left'
                              for='flexSwitchCheckDefault'
                            >
                              Number
                            </label>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              role='switch'
                              id='flexSwitchCheckDefault'
                              checked={variables.kpi15type}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi15type: e.target.checked,
                                }))
                              }
                            />
                            <label
                              className='form-check-label'
                              for='flexSwitchCheckDefault'
                            >
                              Percentage
                            </label>
                          </div>
                        </div>
                        <hr></hr>
                        <div className='row'>
                          <div className='col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center'>
                            <b>Range Down</b>
                            <input
                              className='form-control form-control-sm text-center'
                              type='number'
                              value={variables.kpi15below}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi15below: e.target.value,
                                }))
                              }
                            />
                          </div>
                          <div className='col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center'>
                            <b>Range</b>
                            <input
                              className='form-control form-control-sm text-center'
                              type='number'
                              value={variables.kpi15}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi15: e.target.value,
                                }))
                              }
                            />
                          </div>
                          <div className='col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center'>
                            <b>Range Up</b>
                            <input
                              className='form-control form-control-sm text-center'
                              type='number'
                              value={variables.kpi15above}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi15above: e.target.value,
                                }))
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-4 mb-20'>
                <div className='card'>
                  <div className='card-header'>
                    <h3 className='card-title text-center w-100'>
                      KPI 16: Total Published vs Total Unpublished Courses
                    </h3>
                  </div>
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-12'>
                        <h5 className='text-center'></h5>
                        <div className='self-align-content variable-switch'>
                          <div className='form-check form-switch'>
                            <label
                              className='form-check-label f-left'
                              for='flexSwitchCheckDefault'
                            >
                              Number
                            </label>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              role='switch'
                              id='flexSwitchCheckDefault'
                              checked={variables.kpi16type}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi16type: e.target.checked,
                                }))
                              }
                            />
                            <label
                              className='form-check-label'
                              for='flexSwitchCheckDefault'
                            >
                              Percentage
                            </label>
                          </div>
                        </div>
                        <hr></hr>
                        <div className='row'>
                          <div className='col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center'>
                            <b>Range Down</b>
                            <input
                              className='form-control form-control-sm text-center'
                              type='number'
                              value={variables.kpi16below}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi16below: e.target.value,
                                }))
                              }
                            />
                          </div>
                          <div className='col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center'>
                            <b>Range</b>
                            <input
                              className='form-control form-control-sm text-center'
                              type='number'
                              value={variables.kpi16}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi16: e.target.value,
                                }))
                              }
                            />
                          </div>
                          <div className='col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center'>
                            <b>Range Up</b>
                            <input
                              className='form-control form-control-sm text-center'
                              type='number'
                              value={variables.kpi16above}
                              onChange={(e) =>
                                setVariables((prevState) => ({
                                  ...prevState,
                                  kpi16above: e.target.value,
                                }))
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-4 mb-20">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title text-center w-100">KPI 18: Total Learning Outcomes Linked to Assignments</h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-12">
                    <h5 className="text-center"></h5>
                    <div className="self-align-content variable-switch">
                      <div className="form-check form-switch">
                        <label
                          className="form-check-label f-left"
                          for="flexSwitchCheckDefault"
                        >
                          Number
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="flexSwitchCheckDefault"
                          checked={variables.kpi18type}
                          onChange={(e) =>
                            setVariables((prevState) => ({
                              ...prevState,
                              kpi18type: e.target.checked,
                            }))
                          }
                        />
                        <label
                          className="form-check-label"
                          for="flexSwitchCheckDefault"
                        >
                          Percentage
                        </label>
                      </div>
                    </div>
                    <hr></hr>
                    <div className="row">
                      <div className="col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center">
                        <b>Range Down</b>
                        <input
                          className="form-control form-control-sm text-center"
                          type="number"
                          value={variables.kpi18below}
                          onChange={(e) =>
                            setVariables((prevState) => ({
                              ...prevState,
                              kpi18below: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div className="col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center">
                        <b>Range</b>
                        <input
                          className="form-control form-control-sm text-center"
                          type="number"
                          value={variables.kpi18}
                          onChange={(e) =>
                            setVariables((prevState) => ({
                              ...prevState,
                              kpi18: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div className="col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center">
                        <b>Range Up</b>
                        <input
                          className="form-control form-control-sm text-center"
                          type="number"
                          value={variables.kpi18above}
                          onChange={(e) =>
                            setVariables((prevState) => ({
                              ...prevState,
                              kpi18above: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-4 mb-20">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title text-center w-100">KPI 19: Assignments with Learning Outcomes</h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-12">
                    <h5 className="text-center"></h5>
                    <div className="self-align-content variable-switch">
                      <div className="form-check form-switch">
                        <label
                          className="form-check-label f-left"
                          for="flexSwitchCheckDefault"
                        >
                          Number
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="flexSwitchCheckDefault"
                          checked={variables.kpi19type}
                          onChange={(e) =>
                            setVariables((prevState) => ({
                              ...prevState,
                              kpi19type: e.checked,
                            }))
                          }
                        />
                        <label
                          className="form-check-label"
                          for="flexSwitchCheckDefault"
                        >
                          Percentage
                        </label>
                      </div>
                    </div>
                    <hr></hr>
                    <div className="row">
                      <div className="col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center">
                        <b>Range Down</b>
                        <input
                          className="form-control form-control-sm text-center"
                          type="number"
                          value={variables.kpi19below}
                          onChange={(e) =>
                            setVariables((prevState) => ({
                              ...prevState,
                              kpi19below: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div className="col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center">
                        <b>Range</b>
                        <input
                          className="form-control form-control-sm text-center"
                          type="number"
                          value={variables.kpi19}
                          onChange={(e) =>
                            setVariables((prevState) => ({
                              ...prevState,
                              kpi19: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div className="col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center">
                        <b>Range Up</b>
                        <input
                          className="form-control form-control-sm text-center"
                          type="number"
                          value={variables.kpi19above}
                          onChange={(e) =>
                            setVariables((prevState) => ({
                              ...prevState,
                              kpi19above: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Variables;
